import DateQuestion from './date-question';
import FileQuestion from './file-question';
import MultiselectQuestion from './multiselect-question';
import RadioQuestion from './radio-question';
import SelectQuestion from './select-question';
import StringQuestion from './string-question';
import TextQuestion from './text-question';
import TypeaheadQuestion from './typeahead-question';

const QUESTION_COMPONENTS = {
  multiselect: MultiselectQuestion,
  radio: RadioQuestion,
  select: SelectQuestion,
  string: StringQuestion,
  text: TextQuestion,
  file: FileQuestion,
  date: DateQuestion,
  typeahead: TypeaheadQuestion,
};

export default QUESTION_COMPONENTS;
